import React from 'react';
import { Check } from 'lucide-react';
interface StepIndicatorProps {
  currentStep: number;
}
const steps = [{
  number: 1,
  label: 'Upload'
}, {
  number: 2,
  label: 'Choose'
}, {
  number: 3,
  label: 'Visualize'
}];
export function StepIndicator({
  currentStep
}: StepIndicatorProps) {
  return <div className="w-full py-8" data-id="element-255">
      <div className="flex items-center justify-center space-x-4 md:space-x-8" data-id="element-256">
        {steps.map((step, index) => {
        const isCompleted = currentStep > step.number;
        const isCurrent = currentStep === step.number;
        return <div key={step.number} className="flex items-center" data-id="element-257">
              {/* Line connector */}
              {index > 0 && <div className={`w-8 md:w-16 h-0.5 mr-4 md:mr-8 ${currentStep >= step.number ? 'bg-accent' : 'bg-gray-200'}`} data-id="element-258" />}

              <div className="flex flex-col items-center" data-id="element-259">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors duration-300 ${isCompleted ? 'bg-accent text-white' : isCurrent ? 'bg-accent text-white ring-4 ring-accent/20' : 'bg-gray-100 text-gray-400'}`} data-id="element-260">
                  {isCompleted ? <Check className="w-4 h-4" data-id="element-261" /> : step.number}
                </div>
                <span className={`mt-2 text-xs font-medium uppercase tracking-wider ${isCurrent || isCompleted ? 'text-accent' : 'text-gray-400'}`} data-id="element-262">
                  {step.label}
                </span>
              </div>
            </div>;
      })}
      </div>
    </div>;
}